import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      home: 'Home',
      appointments: 'Appointments',
      grievances: 'Grievances',
      services: 'Services',
      about: 'About Us',
      contact: 'Contact',
      login: 'Login',
      logout: 'Logout',
      dashboard: 'Dashboard',
      
      // Hero
      heroTitle: 'Indian Consular Application Center',
      heroSubtitle: 'Singapore',
      bookAppointment: 'Book Appointment',
      submitGrievance: 'Submit Grievance',
      
      // Services
      ourServices: 'Our Services',
      appointmentService: 'Appointment Management',
      appointmentDesc: 'Schedule and manage your government service appointments online',
      grievanceService: 'Grievance System',
      grievanceDesc: 'Submit and track your complaints and concerns',
      supportService: '24/7 Support',
      supportDesc: 'Get assistance whenever you need it',
      
      // Facts
      factsTitle: 'Our Impact',
      totalAppointments: 'Total Appointments',
      activeCenters: 'Active Centers',
      satisfiedUsers: 'Satisfied Users',
      servicesProvided: 'Services Provided',
      
      // FAQ
      faqTitle: 'Frequently Asked Questions',
      faq1Q: 'How do I book an appointment?',
      faq1A: 'Click on "Book Appointment", fill in your details, verify your email with OTP, and select your preferred date and time slot.',
      faq2Q: 'Can I reschedule my appointment?',
      faq2A: 'Yes, please contact us with your appointment reference ID to reschedule.',
      faq3Q: 'How long does it take to process a grievance?',
      faq3A: 'We aim to review and respond to all grievances within 5-7 business days.',
      faq4Q: 'What documents do I need for my appointment?',
      faq4A: 'Please bring your passport, appointment reference ID, and any relevant supporting documents.',
      faq5Q: 'Is there a fee for services?',
      faq5A: 'Fees vary depending on the service. Please check the specific service details or contact us for more information.',
      
      // Appointment Form
      appointmentTitle: 'Book an Appointment',
      selectCenter: 'Select Center',
      selectCenterDesc: 'Choose a center for your appointment',
      chooseCenterPlaceholder: 'Choose a center...',
      selectTimeSlot: 'Select Time Slot',
      backToCenter: 'Back to Center Selection',
      appointmentDate: 'Appointment Date',
      timeSlot: 'Time Slot',
      applicantName: 'Applicant Name',
      isdCode: 'ISD Code',
      mobileNumber: 'Mobile Number',
      email: 'Email Address',
      sendOTP: 'Send OTP',
      otpCode: 'OTP Code',
      verifyOTP: 'Verify OTP',
      serviceType: 'Service Type',
      serviceName: 'Service Name',
      passportNumber: 'Passport Number',
      serviceDescription: 'Service Description',
      confirmationCheckbox1: 'I confirm that all information provided is accurate',
      confirmationCheckbox2: 'I agree to the terms and conditions',
      reset: 'Reset',
      submit: 'Submit',
      
      // Grievance Form
      grievanceTitle: 'Submit a Grievance',
      yourName: 'Your Name',
      phoneNumber: 'Phone Number',
      subject: 'Subject',
      message: 'Message',
      
      // Admin
      appointmentsManagement: 'Appointments Management',
      grievancesManagement: 'Grievances Management',
      filterByStatus: 'Filter by Status',
      filterByCenter: 'Filter by Center',
      allStatuses: 'All Statuses',
      allCenters: 'All Centers',
      pending: 'Pending',
      approved: 'Approved',
      completed: 'Completed',
      cancelled: 'Cancelled',
      inProgress: 'In Progress',
      resolved: 'Resolved',
      referenceId: 'Reference ID',
      date: 'Date',
      time: 'Time',
      center: 'Center',
      status: 'Status',
      actions: 'Actions',
      updateStatus: 'Update Status',
      adminNotes: 'Admin Notes',
      save: 'Save',
      cancel: 'Cancel',
      
      // Footer
      footerAbout: 'About',
      footerServices: 'Services',
      footerContact: 'Contact',
      footerFollow: 'Follow Us',
      footerCopyright: '©2026 DU Digital Global. All rights reserved.',
      
      // Messages
      loading: 'Loading...',
      success: 'Success',
      error: 'Error',
      otpSent: 'OTP sent successfully',
      otpVerified: 'OTP verified successfully',
      appointmentBooked: 'Appointment booked successfully',
      grievanceSubmitted: 'Grievance submitted successfully',
      pleaseWait: 'Please wait...',
      noData: 'No data available'
    }
  },
  ko: {
    translation: {
      // Navigation
      home: '홈',
      appointments: '예약',
      grievances: '민원',
      services: '서비스',
      about: '소개',
      contact: '연락처',
      login: '로그인',
      logout: '로그아웃',
      dashboard: '대시보드',
      
      // Hero
      heroTitle: '정부 서비스 포털',
      heroSubtitle: '예약 접수, 민원 제출 및 정부 서비스를 쉽게 이용하세요',
      bookAppointment: '예약하기',
      submitGrievance: '민원 제출',
      
      // Services
      ourServices: '우리의 서비스',
      appointmentService: '예약 관리',
      appointmentDesc: '온라인으로 정부 서비스 예약을 예약하고 관리하세요',
      grievanceService: '민원 시스템',
      grievanceDesc: '불만 사항과 우려 사항을 제출하고 추적하세요',
      supportService: '24/7 지원',
      supportDesc: '필요할 때마다 도움을 받으세요',
      
      // Facts
      factsTitle: '우리의 영향',
      totalAppointments: '총 예약',
      activeCenters: '활성 센터',
      satisfiedUsers: '만족한 사용자',
      servicesProvided: '제공된 서비스',
      
      // FAQ
      faqTitle: '자주 묻는 질문',
      faq1Q: '예약은 어떻게 하나요?',
      faq1A: '"예약하기"를 클릭하고 세부 정보를 입력한 후 OTP로 이메일을 확인하고 원하는 날짜와 시간대를 선택하세요.',
      faq2Q: '예약을 변경할 수 있나요?',
      faq2A: '예, 예약 참조 번호로 연락하여 일정을 변경하세요.',
      faq3Q: '민원 처리에 얼마나 걸리나요?',
      faq3A: '모든 민원을 영업일 기준 5-7일 이내에 검토하고 응답하는 것을 목표로 합니다.',
      faq4Q: '예약 시 필요한 서류는 무엇인가요?',
      faq4A: '여권, 예약 참조 번호 및 관련 지원 서류를 가져오세요.',
      faq5Q: '서비스 이용료가 있나요?',
      faq5A: '서비스에 따라 수수료가 다릅니다. 자세한 내용은 특정 서비스 세부 정보를 확인하거나 문의하세요.',
      
      // Appointment Form
      appointmentTitle: '예약하기',
      selectCenter: '센터 선택',
      selectCenterDesc: '예약할 센터를 선택하세요',
      chooseCenterPlaceholder: '센터를 선택하세요...',
      selectTimeSlot: '시간대 선택',
      backToCenter: '센터 선택으로 돌아가기',
      appointmentDate: '예약 날짜',
      timeSlot: '시간대',
      applicantName: '신청자 이름',
      isdCode: '국가 코드',
      mobileNumber: '휴대전화 번호',
      email: '이메일 주소',
      sendOTP: 'OTP 전송',
      otpCode: 'OTP 코드',
      verifyOTP: 'OTP 확인',
      serviceType: '서비스 유형',
      serviceName: '서비스 이름',
      passportNumber: '여권 번호',
      serviceDescription: '서비스 설명',
      confirmationCheckbox1: '제공된 모든 정보가 정확함을 확인합니다',
      confirmationCheckbox2: '이용약관에 동의합니다',
      reset: '재설정',
      submit: '제출',
      
      // Grievance Form
      grievanceTitle: '민원 제출',
      yourName: '이름',
      phoneNumber: '전화번호',
      subject: '제목',
      message: '메시지',
      
      // Admin
      appointmentsManagement: '예약 관리',
      grievancesManagement: '민원 관리',
      filterByStatus: '상태별 필터',
      filterByCenter: '센터별 필터',
      allStatuses: '모든 상태',
      allCenters: '모든 센터',
      pending: '대기 중',
      approved: '승인됨',
      completed: '완료됨',
      cancelled: '취소됨',
      inProgress: '진행 중',
      resolved: '해결됨',
      referenceId: '참조 번호',
      date: '날짜',
      time: '시간',
      center: '센터',
      status: '상태',
      actions: '작업',
      updateStatus: '상태 업데이트',
      adminNotes: '관리자 메모',
      save: '저장',
      cancel: '취소',
      
      // Footer
      footerAbout: '소개',
      footerServices: '서비스',
      footerContact: '연락처',
      footerFollow: '팔로우',
      footerCopyright: '© 2025 ICAC. 모든 권리 보유.',
      
      // Messages
      loading: '로딩 중...',
      success: '성공',
      error: '오류',
      otpSent: 'OTP가 성공적으로 전송되었습니다',
      otpVerified: 'OTP가 성공적으로 확인되었습니다',
      appointmentBooked: '예약이 성공적으로 완료되었습니다',
      grievanceSubmitted: '민원이 성공적으로 제출되었습니다',
      pleaseWait: '잠시 기다려주세요...',
      noData: '데이터가 없습니다'
    }
  },
  th: {
    translation: {
      // Navigation
      home: 'หน้าหลัก',
      appointments: 'การนัดหมาย',
      grievances: 'ข้อร้องเรียน',
      services: 'บริการ',
      about: 'เกี่ยวกับเรา',
      contact: 'ติดต่อ',
      login: 'เข้าสู่ระบบ',
      logout: 'ออกจากระบบ',
      dashboard: 'แดชบอร์ด',
      
      // Hero
      heroTitle: 'พอร์ทัลบริการภาครัฐ',
      heroSubtitle: 'จองนัดหมาย ส่งข้อร้องเรียน และเข้าถึงบริการภาครัฐได้อย่างง่ายดาย',
      bookAppointment: 'จองนัดหมาย',
      submitGrievance: 'ส่งข้อร้องเรียน',
      
      // Services
      ourServices: 'บริการของเรา',
      appointmentService: 'การจัดการนัดหมาย',
      appointmentDesc: 'จัดตารางและจัดการนัดหมายบริการภาครัฐออนไลน์',
      grievanceService: 'ระบบข้อร้องเรียน',
      grievanceDesc: 'ส่งและติดตามข้อร้องเรียนและข้อกังวลของคุณ',
      supportService: 'สนับสนุน 24/7',
      supportDesc: 'รับความช่วยเหลือเมื่อคุณต้องการ',
      
      // Facts
      factsTitle: 'ผลกระทบของเรา',
      totalAppointments: 'การนัดหมายทั้งหมด',
      activeCenters: 'ศูนย์ที่ใช้งานอยู่',
      satisfiedUsers: 'ผู้ใช้ที่พึงพอใจ',
      servicesProvided: 'บริการที่ให้บริการ',
      
      // FAQ
      faqTitle: 'คำถามที่พบบ่อย',
      faq1Q: 'ฉันจะจองนัดหมายได้อย่างไร?',
      faq1A: 'คลิกที่ "จองนัดหมาย" กรอกรายละเอียดของคุณ ยืนยันอีเมลด้วย OTP และเลือกวันและช่วงเวลาที่ต้องการ',
      faq2Q: 'ฉันสามารถเปลี่ยนนัดหมายได้หรือไม่?',
      faq2A: 'ได้ โปรดติดต่อเราพร้อมรหัสอ้างอิงการนัดหมายเพื่อเปลี่ยนกำหนดการ',
      faq3Q: 'การประมวลผลข้อร้องเรียนใช้เวลานานเท่าไหร่?',
      faq3A: 'เรามุ่งมั่นที่จะตรวจสอบและตอบกลับข้อร้องเรียนทั้งหมดภายใน 5-7 วันทำการ',
      faq4Q: 'ฉันต้องใช้เอกสารอะไรบ้างสำหรับการนัดหมาย?',
      faq4A: 'โปรดนำหนังสือเดินทาง รหัสอ้างอิงการนัดหมาย และเอกสารสนับสนุนที่เกี่ยวข้องมาด้วย',
      faq5Q: 'มีค่าธรรมเนียมในการให้บริการหรือไม่?',
      faq5A: 'ค่าธรรมเนียมแตกต่างกันไปตามบริการ โปรดตรวจสอบรายละเอียดบริการเฉพาะหรือติดต่อเราเพื่อขอข้อมูลเพิ่มเติม',
      
      // Appointment Form
      appointmentTitle: 'จองนัดหมาย',
      selectCenter: 'เลือกศูนย์',
      selectCenterDesc: 'เลือกศูนย์สำหรับการนัดหมายของคุณ',
      chooseCenterPlaceholder: 'เลือกศูนย์...',
      selectTimeSlot: 'เลือกช่วงเวลา',
      backToCenter: 'กลับไปเลือกศูนย์',
      appointmentDate: 'วันที่นัดหมาย',
      timeSlot: 'ช่วงเวลา',
      applicantName: 'ชื่อผู้สมัคร',
      isdCode: 'รหัสประเทศ',
      mobileNumber: 'หมายเลขโทรศัพท์มือถือ',
      email: 'ที่อยู่อีเมล',
      sendOTP: 'ส่ง OTP',
      otpCode: 'รหัส OTP',
      verifyOTP: 'ยืนยัน OTP',
      serviceType: 'ประเภทบริการ',
      serviceName: 'ชื่อบริการ',
      passportNumber: 'หมายเลขหนังสือเดินทาง',
      serviceDescription: 'คำอธิบายบริการ',
      confirmationCheckbox1: 'ฉันยืนยันว่าข้อมูลทั้งหมดที่ให้มานั้นถูกต้อง',
      confirmationCheckbox2: 'ฉันยอมรับข้อกำหนดและเงื่อนไข',
      reset: 'รีเซ็ต',
      submit: 'ส่ง',
      
      // Grievance Form
      grievanceTitle: 'ส่งข้อร้องเรียน',
      yourName: 'ชื่อของคุณ',
      phoneNumber: 'หมายเลขโทรศัพท์',
      subject: 'หัวข้อ',
      message: 'ข้อความ',
      
      // Admin
      appointmentsManagement: 'การจัดการนัดหมาย',
      grievancesManagement: 'การจัดการข้อร้องเรียน',
      filterByStatus: 'กรองตามสถานะ',
      filterByCenter: 'กรองตามศูนย์',
      allStatuses: 'สถานะทั้งหมด',
      allCenters: 'ศูนย์ทั้งหมด',
      pending: 'รอดำเนินการ',
      approved: 'อนุมัติแล้ว',
      completed: 'เสร็จสิ้น',
      cancelled: 'ยกเลิกแล้ว',
      inProgress: 'กำลังดำเนินการ',
      resolved: 'แก้ไขแล้ว',
      referenceId: 'รหัสอ้างอิง',
      date: 'วันที่',
      time: 'เวลา',
      center: 'ศูนย์',
      status: 'สถานะ',
      actions: 'การดำเนินการ',
      updateStatus: 'อัปเดตสถานะ',
      adminNotes: 'หมายเหตุผู้ดูแลระบบ',
      save: 'บันทึก',
      cancel: 'ยกเลิก',
      
      // Footer
      footerAbout: 'เกี่ยวกับ',
      footerServices: 'บริการ',
      footerContact: 'ติดต่อ',
      footerFollow: 'ติดตามเรา',
      footerCopyright: '© 2025 ICAC สงวนลิขสิทธิ์',
      
      // Messages
      loading: 'กำลังโหลด...',
      success: 'สำเร็จ',
      error: 'ข้อผิดพลาด',
      otpSent: 'ส่ง OTP สำเร็จ',
      otpVerified: 'ยืนยัน OTP สำเร็จ',
      appointmentBooked: 'จองนัดหมายสำเร็จ',
      grievanceSubmitted: 'ส่งข้อร้องเรียนสำเร็จ',
      pleaseWait: 'กรุณารอสักครู่...',
      noData: 'ไม่มีข้อมูล'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;